<div class="pt-3" *ngIf="customerNotFound">
  <h2>Customer not found.</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="!customerNotFound && (serverError === null)">
  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; height: 39px;">
          <span style="position: relative; top: -2px;">Payment History</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Date</th>
        <th scope="col">Invoice&nbsp;#</th>
        <th scope="col">Purchase</th>
        <th scope="col">Payment Method</th>
        <th scope="col">Total</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingPayments">
      <tr *ngFor="let payment of paymentsList.results">
        <td class="text-nowrap">{{ dateStringFromISO8601(payment.created_date) }}</td>
        <td>#{{ payment.invoice_id }}</td>
        <td>
          {{ payment.invoice_description }}
          <span *ngIf="!payment.invoice_description" class="text-muted">No data</span>
          <ng-container *ngIf="payment.discount_amount">
            <br>
            <span class="text-muted d-inline-block mt-1">
              {{ orgConfigService.formatCurrency(payment.discount_amount) }} discount applied: {{ payment.discount_display_name }}
            </span>
          </ng-container>
        </td>
        <td>
          {{ getPaymentMethodTypeDisplay(payment.payment_type, payment.payment_method_type) }}
          <!--suppress TypeScriptValidateTypes -->
          <ng-container *ngIf="[PaymentType.stripe, PaymentType.gravity, PaymentType.mxMerchant, PaymentType.mock].includes(payment.payment_type)">
            <ng-container *ngIf="(payment.payment_method_type === PaymentMethodType.card) && payment.credit_card_last4">
              <br>
              <span class="text-muted d-inline-block mt-1">
                <span style="text-transform: capitalize" *ngIf="payment.credit_card_brand">{{ payment.credit_card_brand }}</span>
                ending in {{ payment.credit_card_last4 }}
              </span>
            </ng-container>
            <ng-container *ngIf="(payment.payment_method_type === PaymentMethodType.bankAccount) && payment.bank_account_last4">
              <br>
              <span class="text-muted d-inline-block mt-1">
                <span style="text-transform: capitalize" *ngIf="payment.bank_account_bank_name">{{ payment.bank_account_bank_name }}</span>
                ending in {{ payment.bank_account_last4 }}
              </span>
            </ng-container>
          </ng-container>
        </td>
        <td>
          <span [class.cm-strikethrough]="(payment.status === PaymentStatus.partiallyRefunded) || (payment.status === PaymentStatus.refunded) || (payment.status === PaymentStatus.paymentFailed)">
            {{ orgConfigService.formatCurrency(payment.amount) }}
          </span>
          <ng-container *ngIf="payment.status === PaymentStatus.partiallyRefunded">
            <br>
            <span class="text-muted d-inline-block mt-1">
              Partially refunded ({{ orgConfigService.formatCurrency(payment.amount_refunded) }})
            </span>
          </ng-container>
          <ng-container *ngIf="payment.status === PaymentStatus.refunded">
            <br>
            <span class="text-muted d-inline-block mt-1">
              Refunded
            </span>
          </ng-container>
          <ng-container *ngIf="payment.status === PaymentStatus.paymentProcessing">
            <br>
            <span class="text-warning d-inline-block mt-1">
              Processing
            </span>
          </ng-container>
          <ng-container *ngIf="payment.status === PaymentStatus.paymentFailed">
            <br>
            <span class="text-danger d-inline-block mt-1">
              Failed
            </span>
          </ng-container>
          <ng-container *ngIf="payment.pending_refund_amount != null">
            <br>
            <span class="text-warning d-inline-block mt-1">
              Refund of {{ orgConfigService.formatCurrency(payment.pending_refund_amount) }} awaiting confirmation from MX Merchant
            </span>
          </ng-container>
        </td>
        <!-- Set width manually to prevent buttons from wrapping -->
        <td class="table-12px-button-cell" style="width: 108px;">
          <div class="dropdown">
            <button class="btn btn-sm btn-secondary table-12px-button float-right dropdown-toggle"
                    type="button" id="managePaymentDropdown{{ payment.id }}"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Manage
            </button>
            <div class="dropdown-menu" attr.aria-labelledby="managePaymentDropdown{{ payment.id }}">
              <a class="dropdown-item" href="#"
                 *ngIf="!isPOSPayment(payment)"
                 (click)="downloadReceipt(payment);$event.preventDefault();">
                Download
                <span *ngIf="orgConfigService.getOrganizationConfig().tax_display_format === TaxDisplayFormat.vat">VAT</span>
                <span *ngIf="orgConfigService.getOrganizationConfig().tax_display_format === TaxDisplayFormat.gst">GST</span>
                Receipt
              </a>
              <a class="dropdown-item" href="#"
                 *ngIf="canRefundPayment(payment)"
                 (click)="openRefundPaymentModal(payment);$event.preventDefault();">
                View Refund Options
              </a>
              <a class="dropdown-item" href="#"
                 *ngIf="canChangePaymentCustomer(payment)"
                 (click)="openChangePaymentCustomerModal(payment);$event.preventDefault();">
                Change Linked Customer
              </a>
              <a class="dropdown-item" href="#"
                 (click)="openPaymentDetailsModal(payment);$event.preventDefault();">
                View Details
              </a>
            </div>
          </div>
        </td>
      </tr>
      <tr *ngIf="paymentsList.results.length === 0">
        <td colspan="99" class="text-muted">No payments</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingPayments">
      <tr>
        <td colspan="99" class="text-muted">Loading payments...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSizeCustomerPaymentsSubList" (change)="setPage(1)">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="loadingDownload">
      Downloading...
    </div>
  </div>
</div>
